module.exports = __webpack_public_path__ + "img/icon-dexmobile.98ecf3ed.svg";